module.exports = __webpack_public_path__ + "img/ChartKarte.5d04d168.png";